/**
 * Günsonu kasa kaydı sonrası WhatsApp metin raporu.
 * Yarı otomatik: wa.me ile hazır metin açılır, personel Gönder'e basar.
 */

export const GUNSONU_WHATSAPP_SETTINGS_ID = 'gunsonuWhatsapp';

/** wa.me URL için güvenli üst sınır (mobilde kesilmesin diye). */
export const WHATSAPP_TEXT_CHUNK_LIMIT = 1600;

/** Cloud API template {{3}} için üst sınır (Meta body ~1024). */
export const WHATSAPP_CLOUD_CHUNK_LIMIT = 900;

export const BRANCH_LABELS = {
  sefakoy_merkez: 'Sefaköy Merkez',
  sefakoy_sube: 'Sefaköy Şube',
  kavakli_sube: 'Kavaklı Şube',
};

export const BRANCH_COMPARE_ORDER = [
  { key: 'sefakoy_merkez', label: 'Sefaköy Merkez', shortLabel: 'Merkez' },
  { key: 'sefakoy_sube', label: 'Sefaköy Şube', shortLabel: 'Sefaköy Ş.' },
  { key: 'kavakli_sube', label: 'Kavaklı Şube', shortLabel: 'Kavaklı' },
];

export const KASA_CATEGORY_LABELS = {
  sarrafiye: {
    name: 'Sarrafiye',
    field: 'adet',
    unit: 'adet',
    items: {
      eskiZiynetCeyrek: 'Eski Ziynet Çeyrek',
      yeniZiynetCeyrek: 'Yeni Ziynet Çeyrek',
      eskiZiynetYarim: 'Eski Ziynet Yarım',
      yeniZiynetYarim: 'Yeni Ziynet Yarım',
      eskiZiynetTam: 'Eski Ziynet Tam',
      yeniZiynetTam: 'Yeni Ziynet Tam',
      eskiZiynetGremse: "Eski Ziynet 2.5'lu Gremse",
      yeniZiynetGremse: "Yeni Ziynet 2.5'lu Gremse",
      eskiZiynetBesli: 'Eski Ziynet Beşli',
      yeniZiynetBesli: 'Yeni Ziynet Beşli',
      cumhuriyetAtaCeyrek: 'Cumhuriyet Ata Çeyrek',
      cumhuriyetAtaYarim: 'Cumhuriyet Ata Yarım',
      cumhuriyetAta: 'Cumhuriyet Ata',
      cumhuriyetAtaGremse: "Cumhuriyet Ata 2.5'lu Gremse",
      cumhuriyetAtaBesli: 'Cumhuriyet Ata Beşli',
      resatCeyrek: 'Reşat Çeyrek',
      resatYarim: 'Reşat Yarım',
      resat: 'Reşat',
      resatGremse: "Reşat 2.5'lu Gremse",
      resatBesli: 'Reşat Beşli',
    },
  },
  gramAltin: {
    name: 'Gram Altın',
    field: 'adet',
    unit: 'adet',
    items: {
      birGram22Ayar: '1 Gram 22 Ayar',
      yariGram22Ayar: '0.50 Gram 22 Ayar',
      ceyrekGram22Ayar: '0.25 Gram 22 Ayar',
      birGram24Ayar: '1 Gram 24 Ayar',
      yariGram24Ayar: '0.50 Gram 24 Ayar',
      ceyrekGram24Ayar: '0.25 Gram 24 Ayar',
      ikiBucukGram24Ayar: '2.50 Gram 24 Ayar',
      besGram24Ayar: '5 Gram 24 Ayar',
      onGram24Ayar: '10 Gram 24 Ayar',
      yirmiGram24Ayar: '20 Gram 24 Ayar',
      elliGram24Ayar: '50 Gram 24 Ayar',
      yuzGram24Ayar: '100 Gram 24 Ayar',
    },
  },
  hurda: {
    name: 'Hurda',
    field: 'gram',
    unit: 'g',
    items: {
      yirmiDortAyarHurda: '24 Ayar Hurda',
      yirmiIkiAyarBilezikHurda: '22 Ayar Bilezik Hurda',
      yirmiIkiAyarHurda: '22 Ayar Hurda',
      yirmiBirAyarHurda: '21 Ayar Hurda',
      onSekizAyarHurda: '18 Ayar Hurda',
      onDortAyarHurda: '14 Ayar Hurda',
      sekizAyarHurda: '8 Ayar Hurda',
    },
  },
  doviz: {
    name: 'Döviz',
    field: 'adet',
    unit: '',
    items: {
      tl: 'TL',
      usd: 'USD',
      eur: 'EUR',
      gbp: 'GBP',
      chf: 'CHF',
      aud: 'AUD',
      cad: 'CAD',
      sar: 'SAR',
      aed: 'AED',
      qar: 'QAR',
      mad: 'MAD',
      jod: 'JOD',
      kwd: 'KWD',
      cny: 'CNY',
      rub: 'RUB',
      bgn: 'BGN',
    },
  },
};

export function branchLabel(subeKey) {
  return BRANCH_LABELS[subeKey] || String(subeKey || '').replace(/_/g, ' ');
}

export function formatMoneyTr(value) {
  const n = Number(value) || 0;
  return `${n.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} TL`;
}

export function formatQtyTr(value, decimals = 0) {
  const n = Number(value) || 0;
  if (decimals > 0) {
    return n.toLocaleString('tr-TR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    });
  }
  return n.toLocaleString('tr-TR', { maximumFractionDigits: 0 });
}

/** +90 5xx xxx xx xx / 05xx... → 905xxxxxxxxx */
export function normalizePhoneForWhatsapp(phone) {
  let digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '';
  if (digits.startsWith('00')) digits = digits.slice(2);
  if (digits.startsWith('0') && digits.length === 11) digits = `90${digits.slice(1)}`;
  if (digits.length === 10 && digits.startsWith('5')) digits = `90${digits}`;
  return digits;
}

export function partyName(islem) {
  if (islem?.musteri?.isim) {
    return `${islem.musteri.isim} ${islem.musteri.soyisim || ''}`.trim();
  }
  if (islem?.firma?.firmaIsmi) return String(islem.firma.firmaIsmi).trim();
  return 'Tanımsız';
}

function paymentLines(islem) {
  const parts = [];
  const nakit = Number(islem.nakit) || 0;
  const havale = Number(islem.havaleEft) || 0;
  const kart = Number(islem.krediKarti) || 0;
  const bakiye = Number(islem.bakiye) || 0;
  if (nakit) parts.push(`Nakit: ${formatMoneyTr(nakit)}`);
  if (havale) parts.push(`Havale: ${formatMoneyTr(havale)}`);
  if (kart) parts.push(`K.Kartı: ${formatMoneyTr(kart)}`);
  if (bakiye) parts.push(`Bakiye: ${formatMoneyTr(bakiye)}`);
  return parts;
}

function qtyGramLine(islem) {
  const parts = [];
  const adet = Number(islem.adet) || 0;
  const gram = Number(islem.gram) || 0;
  if (adet) parts.push(`${formatQtyTr(adet)} adet`);
  if (gram) parts.push(`${formatQtyTr(gram, 2)} g`);
  const toplam = Number(islem.toplamTutar) || 0;
  if (toplam) parts.push(formatMoneyTr(toplam));
  return parts.join(' · ');
}

export function formatIslemBlock(islem) {
  const no = islem.islemNo || '—';
  const tur = islem.islemTuru || '—';
  const kim = partyName(islem);
  const kat = islem.kategori || '';
  const urun = islem.urun || '';
  const urunLine = [kat, urun].filter(Boolean).join(' — ') || 'Ürün yok';
  const lines = [
    `• #${no} | ${tur} | ${kim}`,
    `  ${urunLine}`,
  ];
  const qty = qtyGramLine(islem);
  if (qty) lines.push(`  ${qty}`);
  const pay = paymentLines(islem);
  if (pay.length) lines.push(`  ${pay.join(' | ')}`);
  return lines.join('\n');
}

export function buildKasaSection(kasaData) {
  const lines = [];
  Object.entries(KASA_CATEGORY_LABELS).forEach(([catKey, cat]) => {
    const catData = kasaData?.[catKey] || {};
    const filled = [];
    Object.entries(cat.items).forEach(([itemKey, label]) => {
      const raw = catData?.[itemKey]?.[cat.field];
      const val = Number(raw) || 0;
      if (Math.abs(val) < 0.0001) return;
      const unit = cat.unit ? ` ${cat.unit}` : '';
      const decimals = cat.field === 'gram' ? 2 : catKey === 'doviz' ? 2 : 0;
      filled.push(`  ${label}: ${formatQtyTr(val, decimals)}${unit}`);
    });
    if (filled.length) {
      lines.push(cat.name);
      lines.push(...filled);
    }
  });
  if (!lines.length) return 'KASA\n  (Dolu kalem yok)';
  return `KASA\n${lines.join('\n')}`;
}

export function summarizeIslemler(islemler) {
  let nakit = 0;
  let havale = 0;
  let kart = 0;
  let bakiye = 0;
  const byTur = {};

  (islemler || []).forEach((islem) => {
    const tur = islem.islemTuru || 'Diğer';
    byTur[tur] = (byTur[tur] || 0) + 1;
    nakit += Number(islem.nakit) || 0;
    havale += Number(islem.havaleEft) || 0;
    kart += Number(islem.krediKarti) || 0;
    bakiye += Number(islem.bakiye) || 0;
  });

  return {
    count: (islemler || []).length,
    byTur,
    nakit,
    havale,
    kart,
    bakiye,
  };
}

export function buildKasaRows(kasaData) {
  const rows = [];
  Object.entries(KASA_CATEGORY_LABELS).forEach(([catKey, cat]) => {
    const catData = kasaData?.[catKey] || {};
    Object.entries(cat.items).forEach(([itemKey, label]) => {
      const raw = catData?.[itemKey]?.[cat.field];
      const val = Number(raw) || 0;
      if (Math.abs(val) < 0.0001) return;
      const decimals = cat.field === 'gram' ? 2 : catKey === 'doviz' ? 2 : 0;
      rows.push({
        category: cat.name,
        label,
        value: formatQtyTr(val, decimals),
        unit: cat.unit || '',
      });
    });
  });
  return rows;
}

export function buildIslemRows(islemler) {
  const sorted = [...(islemler || [])].sort((a, b) => {
    const ta = a.tarih?.getTime?.() || 0;
    const tb = b.tarih?.getTime?.() || 0;
    return ta - tb;
  });

  return sorted.map((islem) => {
    const adet = Number(islem.adet) || 0;
    const gram = Number(islem.gram) || 0;
    const toplam = Number(islem.toplamTutar) || 0;
    const kat = islem.kategori || '';
    const urun = islem.urun || '';
    return {
      no: islem.islemNo || '—',
      tur: islem.islemTuru || '—',
      kim: partyName(islem),
      urun: [kat, urun].filter(Boolean).join(' — ') || '—',
      adet: adet ? formatQtyTr(adet) : '',
      gram: gram ? formatQtyTr(gram, 2) : '',
      tutar: toplam ? formatMoneyTr(toplam) : '',
      odeme: paymentLines(islem).join(' | ') || '—',
    };
  });
}

/**
 * PDF ve API için yapılandırılmış rapor.
 */
export function buildGunsonuReportData({ subeKey, dateLabel, islemler, kasaData }) {
  const sorted = [...(islemler || [])].sort((a, b) => {
    const ta = a.tarih?.getTime?.() || 0;
    const tb = b.tarih?.getTime?.() || 0;
    return ta - tb;
  });
  return {
    branchLabel: branchLabel(subeKey),
    dateLabel: dateLabel || '',
    summary: summarizeIslemler(sorted),
    kasaRows: buildKasaRows(kasaData),
    islemRows: buildIslemRows(sorted),
  };
}

export function buildSummarySection(islemler) {
  const s = summarizeIslemler(islemler);
  const turLine = Object.entries(s.byTur)
    .map(([k, v]) => `${k}: ${v}`)
    .join(' · ');

  const lines = [
    'ÖZET',
    `İşlem: ${s.count}${turLine ? ` (${turLine})` : ''}`,
  ];
  if (s.nakit) lines.push(`Nakit: ${formatMoneyTr(s.nakit)}`);
  if (s.havale) lines.push(`Havale: ${formatMoneyTr(s.havale)}`);
  if (s.kart) lines.push(`K.Kartı: ${formatMoneyTr(s.kart)}`);
  if (s.bakiye) lines.push(`Bakiye: ${formatMoneyTr(s.bakiye)}`);
  return lines.join('\n');
}

/**
 * @returns {{ header: string, summary: string, kasa: string, islemBlocks: string[] }}
 */
export function buildGunsonuReportParts({ subeKey, dateLabel, islemler, kasaData }) {
  const header = [
    'UKBA — Günsonu',
    `Şube: ${branchLabel(subeKey)}`,
    `Tarih: ${dateLabel}`,
  ].join('\n');

  const sorted = [...(islemler || [])].sort((a, b) => {
    const ta = a.tarih?.getTime?.() || 0;
    const tb = b.tarih?.getTime?.() || 0;
    return ta - tb;
  });

  return {
    header,
    summary: buildSummarySection(sorted),
    kasa: buildKasaSection(kasaData),
    islemBlocks: sorted.map(formatIslemBlock),
  };
}

/**
 * WhatsApp karakter limitine göre mesaj parçaları.
 * Önce özet + kasa, sonra işlemler (gerekirse birden fazla).
 */
export function buildGunsonuWhatsappMessages(parts, limit = WHATSAPP_TEXT_CHUNK_LIMIT) {
  const { header, summary, kasa, islemBlocks } = parts;
  const intro = `${header}\n\n${summary}\n\n${kasa}\n\nİŞLEMLER`;

  if (!islemBlocks.length) {
    return [`${intro}\n  (Bugün işlem yok)`];
  }

  const messages = [];
  let current = intro;

  islemBlocks.forEach((block) => {
    const separator = '\n\n';
    if (`${current}${separator}${block}`.length <= limit) {
      current = `${current}${separator}${block}`;
      return;
    }
    messages.push(current);
    current = `${header}\n(devam)\n\nİŞLEMLER${separator}${block}`;
  });
  messages.push(current);

  if (messages.length === 1) return messages;

  const total = messages.length;
  return messages.map((msg, i) => {
    const tag = `(${i + 1}/${total})`;
    if (msg.startsWith('UKBA — Günsonu')) {
      return msg.replace('UKBA — Günsonu', `UKBA — Günsonu ${tag}`);
    }
    return `${tag}\n${msg}`;
  });
}

export function buildWhatsappUrl(phone, text) {
  const digits = normalizePhoneForWhatsapp(phone);
  if (!digits) return '';
  return `https://wa.me/${digits}?text=${encodeURIComponent(text)}`;
}

export function openWhatsappWithText(phone, text) {
  const url = buildWhatsappUrl(phone, text);
  if (!url) return false;
  window.open(url, '_blank', 'noopener,noreferrer');
  return true;
}
